
import MapContainerArcgisTwoD from "@/plugin/gis-viewer/MapContainerArcgis2D.vue";
import MapContainerArcgisThreeD from "@/plugin/gis-viewer/MapContainerArcgis3D.vue";
import MapContainerBaidu from "@/plugin/gis-viewer/MapContainerBaidu.vue";
import MapContainerBaiduGL from "@/plugin/gis-viewer/MapContainerBaiduGL.vue";
import MapContainerGaode from "@/plugin/gis-viewer/MapContainerGaode.vue";
import MapContainerPGIS from "@/plugin/gis-viewer/MapContainerPGIS.vue";
import MapContainerCesium from "@/plugin/gis-viewer/MapContainerCesium.vue";
import MapContainerCloudRender from "@/plugin/gis-viewer/MapContainerCloudRender.vue";
import MapContainerOpenLayer from "@/plugin/gis-viewer/MapContainerOpenLayer.vue";
import { AppModule } from "@/store/modules/app";
import {
    IAnimateLineAddParams,
    IAnimateLineDelParams,
    ICamera,
    ICenterLevel,
    IComponentOverlayParam,
    ICoordinatesTransformParams,
    ICrossCamera,
    ICrossInView,
    ICrossRegionInfo,
    ICustomTip,
    IDefinitionParameter,
    IDistrictParameter,
    IDrawOverlays,
    IDynamicLayerDataParams,
    IFindParameter,
    IGeometrySearchParameter,
    IHeatImageParameter,
    IHeatMapParams,
    IHeatParameter,
    ILaneSignalPhaseInfo,
    ILayerConfig,
    IMapContainer,
    IMapControlParam,
    IMapLevel,
    IMultiStartRoute,
    IOverlayClusterParameter,
    IOverlayDelete,
    IOverlayParameter,
    IPassagewaysParam,
    IPOILocalSearchParameter,
    IPointGeometry,
    IPopUpTemplate,
    IPosition,
    IQueryParameter,
    IResult,
    IRouteHitTestParam,
    IRouteHitTestResultParam,
    IRouteParameter,
    ISelectRouteHitTest,
    ISelectRouteParam,
    ISelectRouteResult,
    IShowSelectedLaneParam,
    ISignalPhaseInfo,
    IStreetParameter,
    ISumoConnectInfo,
    ITrackCross,
    ITrackLineParameter,
    ITrackParameter,
    IWidget,
    Platforms,
    IResultCloudRender,
    IAssetModel,
    RemoveAss,
    ShowPartParameter,
    ShowPartCancelParameter,
} from "@/types/map";
import { Component, Emit, Prop, Ref, Vue } from "vue-property-decorator";
import { TransformCoordinates } from "./Utils";

@Component({
    components: {
        MapContainerOpenLayer,
        MapContainerArcgisThreeD,
        MapContainerArcgisTwoD,
        MapContainerBaidu,
        MapContainerBaiduGL,
        MapContainerGaode,
        MapContainerPGIS,
        MapContainerCesium,
        MapContainerCloudRender,
    },
})
export default class MapContainer extends Vue implements IMapContainer {
    //平台类型 高德/百度/arcgis
    @Prop({ default: Platforms.ArcGIS3D, type: String })
    readonly platform!: string;

    //地图配置
    @Prop({ type: Object }) readonly mapConfig!: Object;

    @Ref() readonly containerArcgis3D!: MapContainerArcgisThreeD;
    @Ref() readonly containerArcgis2D!: MapContainerArcgisTwoD;
    @Ref() readonly containerBaidu!: MapContainerBaidu;
    @Ref() readonly containerBaiduGL!: MapContainerBaiduGL;
    @Ref() readonly containerGaode!: MapContainerGaode;
    @Ref() readonly containerPGIS!: MapContainerPGIS;
    @Ref() readonly containerCesium!: MapContainerCesium;
    @Ref() readonly containerCloudRender!: MapContainerCloudRender;
    @Ref() readonly containerOpenLayer!: MapContainerOpenLayer;

    //当前的地图容器
    get mapContainer(): IMapContainer {
        switch (this.platform) {
            case Platforms.ArcGIS2D:
                return this.containerArcgis2D;
            case Platforms.ArcGIS3D:
                return this.containerArcgis3D;
            case Platforms.BDMap:
                return this.containerBaidu;
            case Platforms.BDMapGL:
                return this.containerBaiduGL;
            case Platforms.AMap:
                return this.containerGaode;
            case Platforms.PGIS_LS:
                return this.containerPGIS;
            case Platforms.CesiumMap:
                return this.containerCesium;
            case Platforms.CloudRenderMap:
                return this.containerCloudRender;
            case Platforms.CloudRenderOpenLayer:
                return this.containerOpenLayer;
            default:
                return this.containerArcgis3D;
        }
    }

    async created() {
        AppModule.setAppConfig(this.mapConfig);

        if ((this.mapConfig as any).arcgis_api && (this.mapConfig as any).arcgis_api.indexOf("arcgis") > -1) {
            (window as any).dojoConfig = {
                async: true,
                tlmSiblingOfDojo: false,
                baseUrl: (this.mapConfig as any).arcgis_api + "/dojo/",
                packages: [
                    {
                        name: "libs",
                        location: "libs",
                    },
                    {
                        name: "fx3d",
                        location: "fx3d/esri",
                    },
                ],
                has: {
                    "esri-promise-compatibility": 1,
                },
            };
        }
    }

    @Emit("map-loaded")
    private mapLoaded(data: any) {
        console.log(data);
        return data;
    }

    @Emit("layer-loaded")
    private layerLoaded() {}

    @Emit("map-click")
    private mapClick(point: object) {}

    @Emit("map-touch")
    private mapTouch(point: object) {}

    @Emit("marker-click")
    private showGisDeviceInfo(type: string, id: string, detail: any, label?: string) {}

    @Emit("double-marker-click")
    private doubleMarkerClick(type: string, id: string, detail: any, label?: string) {}

    @Emit("marker-mouse")
    private mouseGisDeviceInfo(event: any, type: string, id: string, detail: any) {}

    @Emit("select-route-finished")
    private selectedRouteFinished(routeInfo: object) {}

    @Emit("into-signal")
    private intoSignal(signalId: string) {}

    @Emit("outof-signal")
    private outofSignal(signalId: string) {}

    @Emit("map-focused")
    private mapFocused(focusInfo: { type: string; id: string } | undefined) {}

    @Emit("map-interactive")
    private mapInteractive(viewPoint: __esri.Viewpoint) {}

    @Emit("request-next-signal-phase")
    private requestNextSignalPhase(crossId: string) {}

    @Emit("phase-changed")
    private phaseChanged(crossId: string, phase: string) {}

    @Emit("minimap-mouse-over")
    private onMinimapMouseOver() {}

    @Emit("minimap-mouse-out")
    private onMinimapMouseOut() {}

    @Emit("map-zoom")
    private mapZoom(zoom: { new: number; old: number }) {}
    @Emit("map-boundary")
    private mapBoundary(mapB: { topLeft: any; bottomRight: number }) {}

    @Emit("draw-complete")
    private drawCallback(results: any) {}
    public async performExtendAction(params: any): Promise<IResultCloudRender> {
        if (this.mapContainer.performExtendAction) {
            return await this.mapContainer.performExtendAction(params);
        }
        return {
            data: {
                //返回code 200-成功
                code: 500,
                //方法
                command: "performExtendAction",
                msg: "错误",
                data: "1",
            },
        };
    }
    public async setWebsocket(): Promise<any> {
        if (this.mapContainer.setWebsocket) {
            return await this.mapContainer.setWebsocket();
        }
    }

    public async setCameraInfo(params: IAssetModel): Promise<IResultCloudRender> {
        if (this.mapContainer.setCameraInfo) {
            return await this.mapContainer.setCameraInfo(params);
        }
        return {
            data: {
                //返回code 200-成功
                code: 500,
                //方法
                command: "performExtendAction",
                msg: "错误",
                data: "1",
            },
        };
    }
    public async closeClientWebsocket(): Promise<void> {
        if (this.mapContainer.closeClientWebsocket) {
            return await this.mapContainer.closeClientWebsocket();
        }
    }

    public async addAssetModel(params: IAssetModel): Promise<IResult> {
        if (this.mapContainer.addAssetModel) {
            return await this.mapContainer.addAssetModel(params);
        }
        return { status: -2, message: "no function" };
    }
    public async removeAssetModel(params: RemoveAss): Promise<IResult> {
        if (this.mapContainer.removeAssetModel) {
            return await this.mapContainer.removeAssetModel(params);
        }
        return { status: -2, message: "no function" };
    }

    public async addTileLayer(): Promise<IResult> {
        if (this.mapContainer.addTileLayer) {
            return await this.mapContainer.addTileLayer();
        }
        return { status: -2, message: "no function" };
    }
    public async deleteTileLayer(): Promise<IResult> {
        if (this.mapContainer.deleteTileLayer) {
            return await this.mapContainer.deleteTileLayer();
        }
        return { status: -2, message: "no function" };
    }

    public async addOverlays(params: IOverlayParameter): Promise<IResult> {
        if (this.mapContainer.addOverlays) {
            return await this.mapContainer.addOverlays(params);
        }
        return { status: -2, message: "no function" };
    }

    public async addOverlaysLine(params: IOverlayParameter): Promise<IResult> {
        if (this.mapContainer.addOverlaysLine) {
            return await this.mapContainer.addOverlaysLine(params);
        }
        return { status: -2, message: "no function" };
    }

    public async addOverlaysZHZX(params: IOverlayParameter): Promise<IResult> {
        if (this.mapContainer.addOverlaysZHZX) {
            return await this.mapContainer.addOverlaysZHZX(params);
        }
        return { status: -2, message: "no function" };
    }

    public async showToolTip(params: IOverlayDelete): Promise<IResult> {
        if (this.mapContainer.showToolTip) {
            return await this.mapContainer.showToolTip(params);
        }
        return { status: -2, message: "no function" };
    }

    public async hideToolTip(params: IOverlayDelete): Promise<IResult> {
        if (this.mapContainer.hideToolTip) {
            return await this.mapContainer.hideToolTip(params);
        }
        return { status: -2, message: "no function" };
    }

    public async getOverlays(params: IOverlayDelete): Promise<IResult> {
        if (this.mapContainer.getOverlays) {
            return await this.mapContainer.getOverlays(params);
        }
        return { status: -2, message: "no function" };
    }
    public async addOverlaysCluster(params: IOverlayClusterParameter): Promise<IResult> {
        if (this.mapContainer.addOverlaysCluster) {
            return await this.mapContainer.addOverlaysCluster(params);
        }
        return { status: -2, message: "no function" };
    }
    public async addHeatMap(params: IHeatParameter): Promise<IResult> {
        if (this.mapContainer.addHeatMap) {
            return await this.mapContainer.addHeatMap(params);
        }
        return { status: -2, message: "no function" };
    }
    public async addHeatMapFromServer(params: IHeatMapParams): Promise<IResult> {
        if (this.mapContainer.addHeatMapFromServer) {
            return this.mapContainer.addHeatMapFromServer(params);
        }
        return { status: -2, message: "no function" };
    }

    public async deleteOverlays(params: IOverlayDelete): Promise<IResult> {
        if (this.mapContainer.deleteOverlays) {
            return await this.mapContainer.deleteOverlays(params);
        }
        return { status: -2, message: "no function" };
    }
    public async deleteOverlaysLine(params: IOverlayDelete): Promise<IResult> {
        if (this.mapContainer.deleteOverlaysLine) {
            return await this.mapContainer.deleteOverlaysLine(params);
        }
        return { status: -2, message: "no function" };
    }
    public deleteOverlaysCluster(params: IOverlayDelete) {
        if (this.mapContainer.deleteOverlaysCluster) {
            return this.mapContainer.deleteOverlaysCluster(params);
        }
        return { status: -2, message: "no function" };
    }

    public deleteAllOverlays() {
        if (this.mapContainer.deleteAllOverlays) {
            this.mapContainer.deleteAllOverlays();
        }
    }
    public deleteAllOverlaysCluster() {
        if (this.mapContainer.deleteAllOverlaysCluster) {
            this.mapContainer.deleteAllOverlaysCluster();
        }
    }
    public deleteHeatMap(params: ILayerConfig) {
        if (this.mapContainer.deleteHeatMap) {
            this.mapContainer.deleteHeatMap(params);
        }
    }
    public showLayer(params: ILayerConfig) {
        if (this.mapContainer.showLayer) {
            this.mapContainer.showLayer(params);
        }
    }
    public hideLayer(params: ILayerConfig) {
        if (this.mapContainer.hideLayer) {
            this.mapContainer.hideLayer(params);
        }
    }
    public setMapCenter(params: IPointGeometry) {
        if (this.mapContainer.setMapCenter) {
            this.mapContainer.setMapCenter(params);
        }
    }
    public setMapViewpoint(viewpoint: any) {
        if (this.mapContainer.setMapViewpoint) {
            this.mapContainer.setMapViewpoint(viewpoint);
        }
    }
    public async setMapCenterAndLevelZHZX(params: ICenterLevel): Promise<void> {
        if (this.mapContainer.setMapCenterAndLevelZHZX) {
            await this.mapContainer.setMapCenterAndLevelZHZX(params);
        }
    }
    public async setMapCenterAndLevel(params: ICenterLevel): Promise<void> {
        if (this.mapContainer.setMapCenterAndLevel) {
            await this.mapContainer.setMapCenterAndLevel(params);
        }
    }
    public async setMapLevel(params: IMapLevel): Promise<void> {
        if (this.mapContainer.setMapLevel) {
            await this.mapContainer.setMapLevel(params);
        }
    }
    public getMapLevel(): number {
        if (this.mapContainer.getMapLevel) {
            return this.mapContainer.getMapLevel();
        } else {
            return 0;
        }
    }

    public async measure_length(): Promise<IResult> {
        if (this.mapContainer.measure_length) {
            return await this.mapContainer.measure_length();
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public async measure_area(): Promise<IResult> {
        if (this.mapContainer.measure_area) {
            return await this.mapContainer.measure_area();
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public measure_clear() {
        if (this.mapContainer.measure_clear) {
            this.mapContainer.measure_clear();
        }
    }

    public async setMapScaleFactor(facotr: number) {
        if (this.mapContainer.setMapScaleFactor) {
            await this.mapContainer.setMapScaleFactor(facotr);
        }
    }
    public async setMapCamera(params: ICamera) {
        if (this.mapContainer.setMapCamera) {
            await this.mapContainer.setMapCamera(params);
        }
    }
    public showJurisdiction() {
        if (this.mapContainer.showJurisdiction) {
            this.mapContainer.showJurisdiction();
        }
    }
    public hideJurisdiction() {
        if (this.mapContainer.hideJurisdiction) {
            this.mapContainer.hideJurisdiction();
        }
    }
    public showDistrictMask(params: IDistrictParameter) {
        if (this.mapContainer.showDistrictMask) {
            this.mapContainer.showDistrictMask(params);
        }
    }
    public hideDistrictMask() {
        if (this.mapContainer.hideDistrictMask) {
            this.mapContainer.hideDistrictMask();
        }
    }
    public async findFeature(params: IFindParameter): Promise<IResult> {
        if (this.mapContainer.findFeature) {
            return await this.mapContainer.findFeature(params);
        }
        return { status: -2, message: "no function" };
    }
    public async findFeatureYp(params: IFindParameter): Promise<IResult> {
        if (this.mapContainer.findFeatureYp) {
            return await this.mapContainer.findFeatureYp(params);
        }
        return { status: -2, message: "no function" };
    }
    public stopHighlightFeature(): void {
        if (this.mapContainer.stopHighlightFeature) {
            this.mapContainer.stopHighlightFeature();
        }
    }
    public showRoad(param: { ids: string[] }) {
        if (this.mapContainer.showRoad) {
            this.mapContainer.showRoad(param);
        }
    }
    public hideRoad() {
        if (this.mapContainer.hideRoad) {
            this.mapContainer.hideRoad();
        }
    }
    public showStreet() {
        if (this.mapContainer.showStreet) {
            this.mapContainer.showStreet();
        }
    }
    public hideStreet() {
        if (this.mapContainer.hideStreet) {
            this.mapContainer.hideStreet();
        }
    }
    public locateStreet(param: IStreetParameter) {
        if (this.mapContainer.locateStreet) {
            this.mapContainer.locateStreet(param);
        }
    }
    public setMapStyle(param: string) {
        if (this.mapContainer.setMapStyle) {
            this.mapContainer.setMapStyle(param);
        }
    }
    public async routeSearch(params: IRouteParameter): Promise<IResult> {
        if (this.mapContainer.routeSearch) {
            return await this.mapContainer.routeSearch(params);
        }
        return { status: -2, message: "no function" };
    }
    public clearRouteSearch() {
        if (this.mapContainer.clearRouteSearch) {
            this.mapContainer.clearRouteSearch();
        }
    }
    public showRoutePoint(params: any) {
        if (this.mapContainer.showRoutePoint) {
            this.mapContainer.showRoutePoint(params);
        }
    }
    public clearRoutePoint() {
        if (this.mapContainer.clearRoutePoint) {
            this.mapContainer.clearRoutePoint();
        }
    }
    public async searchShortestPath(params: IRouteParameter): Promise<IResult> {
        if (this.mapContainer.searchShortestPath) {
            return this.mapContainer.searchShortestPath(params);
        }
        return { status: -2, message: "no function" };
    }
    public async clearShortestPath(): Promise<IResult> {
        if (this.mapContainer.clearShortestPath) {
            return this.mapContainer.clearShortestPath();
        }
        return { status: -2, message: "no function" };
    }
    public async addDrawLayer(params: any): Promise<IResult> {
        if (this.mapContainer.addDrawLayer) {
            return this.mapContainer.addDrawLayer(params);
        }
        return { status: -2, message: "no function" };
    }
    public clearDrawLayer(params: ILayerConfig) {
        if (this.mapContainer.clearDrawLayer) {
            return this.mapContainer.clearDrawLayer(params);
        }
    }
    public addHeatImage(params: IHeatImageParameter) {
        if (this.mapContainer.addHeatImage) {
            this.mapContainer.addHeatImage(params);
        }
    }
    public deleteHeatImage() {
        if (this.mapContainer.deleteHeatImage) {
            this.mapContainer.deleteHeatImage();
        }
    }
    public showMigrateChart(params: any) {
        if (this.mapContainer.showMigrateChart) {
            this.mapContainer.showMigrateChart(params);
        }
    }
    public showODData(params: any) {
        if (this.mapContainer.showODData) {
            this.mapContainer.showODData(params);
        }
    }

    public showSubwayMigrateChart(params: any) {
        if (this.mapContainer.showSubwayMigrateChart) {
            this.mapContainer.showSubwayMigrateChart(params);
        }
    }
    public hideMigrateChart(params?: { custom: boolean }) {
        if (this.mapContainer.hideMigrateChart) {
            this.mapContainer.hideMigrateChart(params);
        }
    }
    public showBarChart(params: any) {
        if (this.mapContainer.showBarChart) {
            this.mapContainer.showBarChart(params);
        }
    }
    public hideBarChart() {
        if (this.mapContainer.hideBarChart) {
            this.mapContainer.hideBarChart();
        }
    }
    public async startGeometrySearch(params: IGeometrySearchParameter): Promise<IResult> {
        if (this.mapContainer.startGeometrySearch) {
            return await this.mapContainer.startGeometrySearch(params);
        }
        return { status: -2, message: "no function" };
    }
    public clearGeometrySearch() {
        if (this.mapContainer.clearGeometrySearch) {
            this.mapContainer.clearGeometrySearch();
        }
    }
    public async showDgene(params: any): Promise<IResult> {
        if (this.mapContainer.showDgene) {
            return await this.mapContainer.showDgene(params);
        }
        return { status: -2, message: "no function" };
    }
    public hideDgene() {
        if (this.mapContainer.hideDgene) {
            this.mapContainer.hideDgene();
        }
    }
    public async addDgeneFusion(params: any): Promise<IResult> {
        if (this.mapContainer.addDgeneFusion) {
            return await this.mapContainer.addDgeneFusion(params);
        }
        return { status: -2, message: "no function" };
    }
    public async restoreDegeneFsion(): Promise<IResult> {
        if (this.mapContainer.restoreDegeneFsion) {
            return await this.mapContainer.restoreDegeneFsion();
        }
        return { status: -2, message: "no function" };
    }
    public showCustomTip(params: ICustomTip) {
        if (this.mapContainer.showCustomTip) {
            this.mapContainer.showCustomTip(params);
        }
    }
    public showDgeneOutPoint(params: any) {
        if (this.mapContainer.showDgeneOutPoint) {
            this.mapContainer.showDgeneOutPoint(params);
        }
    }
    public changeDgeneOut() {
        if (this.mapContainer.changeDgeneOut) {
            this.mapContainer.changeDgeneOut();
        }
    }
    public clearArrowLayer() {
        if (this.mapContainer.clearArrowLayer) {
            this.mapContainer.clearArrowLayer();
        }
    }
    public async initializeRouteSelect(params: ISelectRouteParam) {
        if (this.mapContainer.initializeRouteSelect) {
            await this.mapContainer.initializeRouteSelect(params);
        }
    }

    public async showSelectedRoute(params: ISelectRouteResult) {
        if (this.mapContainer.showSelectedRoute) {
            await this.mapContainer.showSelectedRoute(params);
        }
    }

    public async playSelectedRoute(speed: number) {
        if (this.mapContainer.playSelectedRoute) {
            await this.mapContainer.playSelectedRoute(speed);
        }
    }

    public stopPlaySelectedRoute() {
        if (this.mapContainer.stopPlaySelectedRoute) {
            this.mapContainer.stopPlaySelectedRoute();
        }
    }

    public async routeHitArea(params: ISelectRouteHitTest): Promise<IResult> {
        if (this.mapContainer.routeHitArea) {
            return await this.mapContainer.routeHitArea(params);
        }
        return { status: -2, message: "no function" };
    }
    public async areaHitRoute(params: ISelectRouteHitTest): Promise<IResult> {
        if (this.mapContainer.areaHitRoute) {
            return await this.mapContainer.areaHitRoute(params);
        }
        return { status: -2, message: "no function" };
    }
    // 画点、画线、画多边形
    public async startDrawOverlays(params: IDrawOverlays): Promise<void> {
        if (this.mapContainer.startDrawOverlays) {
            return await this.mapContainer.startDrawOverlays(params);
        }
    }
    // 停止绘制
    public async stopDrawOverlays(): Promise<void> {
        if (this.mapContainer.stopDrawOverlays) {
            return await this.mapContainer.stopDrawOverlays();
        }
    }
    // 获取绘制结果、获取地图上所有绘制的覆盖物结果
    public async getDrawOverlays(): Promise<IResult> {
        if (this.mapContainer.getDrawOverlays) {
            return await this.mapContainer.getDrawOverlays();
        }
        return { status: -2, message: "no function" };
    }
    // 删除绘制结果
    public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {
        if (this.mapContainer.deleteDrawOverlays) {
            return await this.mapContainer.deleteDrawOverlays(params);
        }
    }
    // 图层展示部分
    public async showPart(params: ShowPartParameter): Promise<void> {
        if (this.mapContainer.showPart) {
            return await this.mapContainer.showPart(params);
        }
    }
    // 取消图层展示部分
    public async showPartCancel(params: ShowPartCancelParameter): Promise<void> {
        if (this.mapContainer.showPartCancel) {
            return await this.mapContainer.showPartCancel(params);
        }
    }
    // 置顶图层
    public moveLayerToTop(params: any): IResult {
        if (this.mapContainer.moveLayerToTop) {
            return this.mapContainer.moveLayerToTop(params);
        }
        return { status: -2, message: "no function" };
    }
    // 调整图层顺序
    public reorderLayer(params: any): IResult {
        if (this.mapContainer.reorderLayer) {
            return this.mapContainer.reorderLayer(params);
        }
        return { status: -2, message: "no function" };
    }
    // 切换地图底图
    public changeBaseLayer(params: any): IResult {
        if (this.mapContainer.changeBaseLayer) {
            return this.mapContainer.changeBaseLayer(params);
        }
        return { status: -2, message: "no function" };
    }
    public async startLayerSearch(params: IGeometrySearchParameter): Promise<IResult> {
        if (this.mapContainer.startLayerSearch) {
            return await this.mapContainer.startLayerSearch(params);
        }
        return { status: -2, message: "no function" };
    }
    public async startLayerDefinition(params: IDefinitionParameter): Promise<void> {
        if (this.mapContainer.startLayerDefinition) {
            return await this.mapContainer.startLayerDefinition(params);
        }
    }
    public async startTrackPlay(params: ITrackParameter): Promise<void> {
        if (this.mapContainer.startTrackPlay) {
            return await this.mapContainer.startTrackPlay(params);
        }
    }
    public stopTrackPlay() {
        if (this.mapContainer.stopTrackPlay) {
            this.mapContainer.stopTrackPlay();
        }
    }
    public async getRegionOverlays(params: IOverlayParameter): Promise<IResult> {
        if (this.mapContainer.getRegionOverlays) {
            return await this.mapContainer.getRegionOverlays(params);
        }
        return { status: -2, message: "no function" };
    }

    public async connectSumo(params: ISumoConnectInfo): Promise<IResult> {
        if (this.mapContainer.connectSumoSimulation) {
            return await this.mapContainer.connectSumoSimulation(params);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public disconnectSumo() {
        if (this.mapContainer.disconnectSumoSimulation) {
            this.mapContainer.disconnectSumoSimulation();
        }
    }

    public async connectRealTimeSimulation(params: ISumoConnectInfo): Promise<IResult> {
        if (this.mapContainer.connectRealTimeSimulation) {
            return await this.mapContainer.connectRealTimeSimulation(params);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public disconnectRealTimeSimulation() {
        if (this.mapContainer.disconnectRealTimeSimulation) {
            this.mapContainer.disconnectRealTimeSimulation();
        }
    }

    public focusOnVehicle(id: string) {
        if (this.mapContainer.focusOnVehicle) {
            this.mapContainer.focusOnVehicle(id);
        }
    }

    public cancelFocusOnVehicle() {
        if (this.mapContainer.cancelFocusOnVehicle) {
            this.mapContainer.cancelFocusOnVehicle();
        }
    }

    public async toggleWatchMapFocus(params: { types: string[] }) {
        if (this.mapContainer.toggleWatchMapFocus) {
            this.mapContainer.toggleWatchMapFocus(params);
        }
    }

    public async startWatchMapFocus() {
        if (this.mapContainer.startWatchMapFocus) {
            await this.mapContainer.startWatchMapFocus();
        }
    }

    public stopWatchMapFocus() {
        if (this.mapContainer.stopWatchMapFocus) {
            this.mapContainer.stopWatchMapFocus();
        }
    }

    public startWatchMapCenter() {
        if (this.mapContainer.startWatchMapCenter) {
            this.mapContainer.startWatchMapCenter();
        }
    }

    public stopWatchMapCenter() {
        if (this.mapContainer.stopWatchMapCenter) {
            this.mapContainer.stopWatchMapCenter();
        }
    }

    public async setMapFocus(focusInfo: { type: string; id: string; scaleFactor?: number; highlightOpt?: any }): Promise<IResult> {
        if (this.mapContainer.setMapFocus) {
            return this.mapContainer.setMapFocus(focusInfo);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public async addAnimatePoints(params: IOverlayParameter): Promise<IResult> {
        if (this.mapContainer.addAnimatePoints) {
            return await this.mapContainer.addAnimatePoints(params);
        }
        return { status: -2, message: "no function" };
    }
    public async deleteAnimatePoints(params?: IOverlayDelete): Promise<IResult> {
        if (this.mapContainer.deleteAnimatePoints) {
            return await this.mapContainer.deleteAnimatePoints(params);
        }
        return { status: -2, message: "no function" };
    }

    public async addAnimateLines(params: IAnimateLineAddParams): Promise<IResult> {
        if (this.mapContainer.addAnimateLines) {
            return this.mapContainer.addAnimateLines(params);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public async deleteAnimateLines(params: IAnimateLineDelParams): Promise<IResult> {
        if (this.mapContainer.deleteAnimateLines) {
            return this.mapContainer.deleteAnimateLines(params);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public async startSignalPhase(params: ISignalPhaseInfo): Promise<IResult> {
        if (this.mapContainer.startSignalPhase) {
            return await this.mapContainer.startSignalPhase(params);
        }
        return { status: -2, message: "no function" };
    }

    public async startDrawCrossRegion(params?: { tool?: string }): Promise<IResult> {
        return this.mapContainer.startDrawCrossRegion ? this.mapContainer.startDrawCrossRegion(params) : { status: -2, message: "no function" };
    }

    public stopDrawCrossRegion() {
        if (this.mapContainer.stopDrawCrossRegion) {
            this.mapContainer.stopDrawCrossRegion();
        }
    }

    public async startDeleteCrossRegion(): Promise<IResult> {
        return this.mapContainer.startDeleteCrossRegion ? this.mapContainer.startDeleteCrossRegion() : { status: -2, message: "no function" };
    }

    public stopDeleteCrossRegion() {
        if (this.mapContainer.stopDeleteCrossRegion) {
            this.mapContainer.stopDeleteCrossRegion();
        }
    }

    public showCrossRegions(params: { regions: Array<ICrossRegionInfo> }) {
        if (this.mapContainer.showCrossRegions) {
            this.mapContainer.showCrossRegions(params);
        }
    }

    public hideCrossRegions() {
        if (this.mapContainer.hideCrossRegions) {
            this.mapContainer.hideCrossRegions();
        }
    }

    public toggleBuildingLayer(visible: boolean) {
        if (this.mapContainer.toggleBuildingLayer) {
            this.mapContainer.toggleBuildingLayer(visible);
        }
    }
    public async showPopup(params: IPopUpTemplate) {
        if (this.mapContainer.showPopup) {
            this.mapContainer.showPopup(params);
        }
    }
    public closePopup() {
        if (this.mapContainer.closePopup) {
            this.mapContainer.closePopup();
        }
    }
    public toggleWidget(params: string[]) {
        if (this.mapContainer.toggleWidget) {
            this.mapContainer.toggleWidget(params);
        }
    }
    public setWidgetPos(params: Array<IWidget>) {
        if (this.mapContainer.setWidgetPos) {
            this.mapContainer.setWidgetPos(params);
        }
    }
    public setMinimapPosition(params: IPosition) {
        if (this.mapContainer.setMinimapPosition) {
            this.mapContainer.setMinimapPosition(params);
        }
    }

    public queryCrossInView(params: ICrossInView): IResult {
        return this.mapContainer.queryCrossInView ? this.mapContainer.queryCrossInView(params) : { status: -2, message: "no function" };
    }

    public clearCrossInView() {
        if (this.mapContainer.clearCrossInView) {
            this.mapContainer.clearCrossInView();
        }
    }
    public toggleLayerByYear(year: string) {
        if (this.mapContainer.toggleLayerByYear) {
            this.mapContainer.toggleLayerByYear(year);
        }
    }
    public setCrossCamera(params: ICrossCamera) {
        if (this.mapContainer.setCrossCamera) {
            this.mapContainer.setCrossCamera(params);
        }
    }
    public clearCrossCamera() {
        if (this.mapContainer.clearCrossCamera) {
            this.mapContainer.clearCrossCamera();
        }
    }
    public async addMiniMapPoints(params: IOverlayParameter) {
        if (this.mapContainer.addMiniMapPoints) {
            return this.mapContainer.addMiniMapPoints(params);
        }
        return { status: -2, message: "no function" };
    }

    public async initPassageWall(params: { roadUrl: string }): Promise<IResult> {
        if (this.mapContainer.initPassageWall) {
            return await this.mapContainer.initPassageWall(params);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public async addPassageWall(params: IPassagewaysParam) {
        if (this.mapContainer.addPassageWall) {
            return this.mapContainer.addPassageWall(params);
        }
        return { status: -2, message: "no function" };
    }

    public async deletePassageWall() {
        if (this.mapContainer.deletePassageWall) {
            return this.mapContainer.deletePassageWall();
        }
        return { status: -2, message: "no function" };
    }

    public async addQueryIntersect(params: IQueryParameter) {
        if (this.mapContainer.addQueryIntersect) {
            return this.mapContainer.addQueryIntersect(params);
        }
    }
    public async deleteQueryIntersect(params: string | undefined) {
        if (this.mapContainer.deleteQueryIntersect) {
            return this.mapContainer.deleteQueryIntersect(params);
        }
    }

    public async route_initialize(params?: { cameraUrl: string; token: string; showRoad?: boolean }) {
        if (this.mapContainer.route_initialize) {
            return this.mapContainer.route_initialize(params);
        }
    }

    public async route_addStartPoint(): Promise<IResult> {
        if (this.mapContainer.route_addStartPoint) {
            return this.mapContainer.route_addStartPoint();
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public async route_addEndPoint(): Promise<IResult> {
        if (this.mapContainer.route_addEndPoint) {
            return this.mapContainer.route_addEndPoint();
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public async route_addWayPoint(index: number): Promise<IResult> {
        if (this.mapContainer.route_addWayPoint) {
            return this.mapContainer.route_addWayPoint(index);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public route_deleteWayPoint(index: number): IResult {
        if (this.mapContainer.route_deleteWayPoint) {
            return this.mapContainer.route_deleteWayPoint(index);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public async route_getRoute(): Promise<IResult> {
        if (this.mapContainer.route_getRoute) {
            return this.mapContainer.route_getRoute();
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public async route_getMultiRoutes(params: IMultiStartRoute): Promise<IResult> {
        if (this.mapContainer.route_getMultiRoutes) {
            return this.mapContainer.route_getMultiRoutes(params);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public async route_showRoute(params: { strategy?: string; coordinates?: string; signalIds?: string[] }): Promise<IResult> {
        if (this.mapContainer.route_showRoute) {
            return this.mapContainer.route_showRoute(params);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public async route_clearRoutes() {
        if (this.mapContainer.route_clearRoutes) {
            await this.mapContainer.route_clearRoutes();
        }
    }

    public async route_focusCross(crossId: string): Promise<IResult> {
        if (this.mapContainer.route_focusCross) {
            return this.mapContainer.route_focusCross(crossId);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public route_play(speed: number) {
        if (this.mapContainer.route_play) {
            this.mapContainer.route_play(speed);
        }
    }

    public route_stop() {
        if (this.mapContainer.route_stop) {
            this.mapContainer.route_stop();
        }
    }

    public route_pause() {
        if (this.mapContainer.route_pause) {
            this.mapContainer.route_pause();
        }
    }

    public route_resume() {
        if (this.mapContainer.route_resume) {
            this.mapContainer.route_resume();
        }
    }

    public async route_routeHitArea(params: IRouteHitTestParam): Promise<IResult> {
        if (this.mapContainer.route_routeHitArea) {
            return await this.mapContainer.route_routeHitArea(params);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public async route_areaHitRoute(params: IRouteHitTestParam): Promise<IResult> {
        if (this.mapContainer.route_areaHitRoute) {
            return await this.mapContainer.route_areaHitRoute(params);
        } else {
            return { status: -2, message: "no function" };
        }
    }

    public route_showHitResult(params: IRouteHitTestResultParam) {
        if (this.mapContainer.route_showHitResult) {
            this.mapContainer.route_showHitResult(params);
        }
    }

    public test() {
        if (this.mapContainer.test) {
            this.mapContainer.test();
        }
    }

    public initializeLaneSignalPhase(crossId: string) {
        if (this.mapContainer.initializeLaneSignalPhase) {
            this.mapContainer.initializeLaneSignalPhase(crossId);
        }
    }

    public startLaneSignalPhase(laneSignalPhaseInfos: ILaneSignalPhaseInfo[]) {
        if (this.mapContainer.startLaneSignalPhase) {
            this.mapContainer.startLaneSignalPhase(laneSignalPhaseInfos);
        }
    }

    public stopLaneSignalPhase(crossId: string) {
        if (this.mapContainer.stopLaneSignalPhase) {
            this.mapContainer.stopLaneSignalPhase(crossId);
        }
    }

    public stopAllLaneSignalPhase() {
        if (this.mapContainer.stopAllLaneSignalPhase) {
            this.mapContainer.stopAllLaneSignalPhase();
        }
    }

    public async startTrackLine(params: ITrackLineParameter): Promise<IResult> {
        if (this.mapContainer.startTrackLine) {
            return await this.mapContainer.startTrackLine(params);
        }
        return { status: -2, message: "no function" };
    }
    public stopTrackLine() {
        if (this.mapContainer.stopTrackLine) {
            this.mapContainer.stopTrackLine();
        }
    }
    public async getMapOption(): Promise<IResult> {
        if (this.mapContainer.getMapOption) {
            return await this.mapContainer.getMapOption();
        }
        return { status: -2, message: "no function" };
    }

    public async showCrossTrack(crosses: Array<ITrackCross>) {
        if (this.mapContainer.showCrossTrack) {
            this.mapContainer.showCrossTrack(crosses);
        }
    }

    public showCrossTrackHighlight(crossId: string) {
        if (this.mapContainer.showCrossTrackHighlight) {
            this.mapContainer.showCrossTrackHighlight(crossId);
        }
    }

    public hideCrossTrack() {
        if (this.mapContainer.hideCrossTrack) {
            this.mapContainer.hideCrossTrack();
        }
    }
    public async addPointCollection(params: IOverlayParameter): Promise<IResult> {
        if (this.mapContainer.addPointCollection) {
            return await this.mapContainer.addPointCollection(params);
        }
        return { status: 0, message: "no function" };
    }
    public async deletePointCollection(params: IOverlayDelete): Promise<IResult> {
        if (this.mapContainer.deletePointCollection) {
            return await this.mapContainer.deletePointCollection(params);
        }
        return { status: 0, message: "no function" };
    }
    public async findPointCollection(params: IFindParameter): Promise<IResult> {
        if (this.mapContainer.findPointCollection) {
            return await this.mapContainer.findPointCollection(params);
        }
        return { status: 0, message: "no function" };
    }
    public async showOverlays(params: IOverlayDelete): Promise<IResult> {
        if (this.mapContainer.showOverlays) {
            return await this.mapContainer.showOverlays(params);
        }
        return { status: 0, message: "no function" };
    }
    public async hideOverlays(params: IOverlayDelete): Promise<IResult> {
        if (this.mapContainer.hideOverlays) {
            return await this.mapContainer.hideOverlays(params);
        }
        return { status: 0, message: "no function" };
    }

    public async dynamicLayer_initialize(configFile: string): Promise<void> {
        if (this.mapContainer.dynamicLayer_initialize) {
            await this.mapContainer.dynamicLayer_initialize(configFile);
        } else {
            console.log("接口不存在: dynamicLayer_initialize");
        }
    }

    public async dynamicLayer_show(params: IDynamicLayerDataParams): Promise<void> {
        if (this.mapContainer.dynamicLayer_show) {
            await this.mapContainer.dynamicLayer_show(params);
        } else {
            console.log("接口不存在: dynamicLayer_show");
        }
    }

    public dynamicLayer_hide(params: IDynamicLayerDataParams) {
        if (this.mapContainer.dynamicLayer_hide) {
            this.mapContainer.dynamicLayer_hide(params);
        }
    }

    public async selectLane_initialize() {
        if (this.mapContainer.selectLane_initialize) {
            await this.mapContainer.selectLane_initialize();
        }
    }

    public selectLane_getResult(): IResult {
        if (this.mapContainer.selectLane_getResult) {
            return this.mapContainer.selectLane_getResult();
        } else {
            return { status: 0, message: "no function" };
        }
    }

    public selectLane_showLanes(params: IShowSelectedLaneParam[]): void {
        if (this.mapContainer.selectLane_showLanes) {
            this.mapContainer.selectLane_showLanes(params);
        }
    }

    public async jsonLayer_add(params: ILayerConfig): Promise<void> {
        if (this.mapContainer.jsonLayer_add) {
            await this.mapContainer.jsonLayer_add(params);
        }
    }

    public toScreen(params: { x: number; y: number }): IResult {
        if (this.mapContainer.toScreen) {
            return this.mapContainer.toScreen(params);
        } else {
            return { status: -1, message: "no function" };
        }
    }

    public toMap(params: { x: number; y: number }): IResult {
        if (this.mapContainer.toMap) {
            return this.mapContainer.toMap(params);
        } else {
            return { status: -1, message: "no function" };
        }
    }

    public showImage() {
        if (this.mapContainer.showImage) {
            this.mapContainer.showImage();
        }
    }

    public async addComponentOverlay(params: IComponentOverlayParam): Promise<IResult> {
        if (this.mapContainer.addComponentOverlay) {
            return await this.mapContainer.addComponentOverlay(params);
        } else {
            return { status: -1, message: "no function" };
        }
    }

    public deleteComponentOverlay(params?: IOverlayDelete): IResult {
        if (this.mapContainer.deleteComponentOverlay) {
            return this.mapContainer.deleteComponentOverlay(params);
        } else {
            return { status: -1, message: "no function" };
        }
    }

    public async addCustomComponentOverlay(params: IComponentOverlayParam): Promise<IResult> {
        if (this.mapContainer.addCustomComponentOverlay) {
            return await this.mapContainer.addCustomComponentOverlay(params);
        } else {
            return { status: -1, message: "no function" };
        }
    }

    public getView() {
        return this.mapContainer.view;
    }

    public async setMapControl(params: IMapControlParam) {
        if (this.mapContainer.setMapControl) {
            this.mapContainer.setMapControl(params);
        }
    }

    public async localSearch(params: IPOILocalSearchParameter): Promise<IResult> {
        if (this.mapContainer.localSearch) {
            return this.mapContainer.localSearch(params);
        }
        return { status: -1, message: "no function" };
    }

    public transformCoordinates(params: ICoordinatesTransformParams): IResult {
        let result = TransformCoordinates(params.origin, params.target, params.coords);
        if (result) {
            return {
                status: 1,
                message: `transform ${params.origin} to ${params.target} successfully`,
                result: result,
            };
        } else {
            return {
                status: 0,
                message: `transform ${params.origin} to ${params.target} failed`,
            };
        }
    }

    
}
